<script >
import { ref, defineProps } from '@vue/composition-api';
import { default as FormAddress } from '@/components/steps/formAddress';
import { default as FormDataSeller } from './step/formDataSeller';
import { useWizardForm } from '@/composable/useWizardForm';
import { useCreateSeller } from '@/api/transport/seller/query';
const __sfc_main = {};
__sfc_main.props = {
  closeModal: {
    type: Function
  },
  seller: {
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const STEP_TOTAL = 2;
  const props = __props;
  const formData = ref({
    formStep01: {
      sellerCode: props.seller.seller_code,
      sellerName: props.seller.seller_name,
      customerCode: props.seller.customer_code,
      customerName: props.seller.customer_name,
      phone: props.seller.phone,
      email: props.seller.email,
      document: props.seller.document,
      nameContact: props.seller.nameContact
    },
    formStep02: {
      zipcode: props.seller.seller_zipcode,
      street: props.seller.seller_address,
      number: null,
      neighborhood: props.seller.seller_address_neighborhood,
      municipality: props.seller.seller_address_municipality,
      state: props.seller.seller_state,
      complement: props.seller.complement
    }
  });
  const {
    mutate,
    isLoading
  } = useCreateSeller();
  function handleSubmit(formData) {
    const newSeller = {
      ...formData.value.formStep01,
      ...formData.value.formStep02
    };
    mutate(newSeller, {
      onSuccess: () => {
        props.closeModal();
      }
    });
  }
  const {
    step,
    handleNextStep,
    handlePreviousStep,
    isLastStep,
    isFirstStep
  } = useWizardForm(formData, handleSubmit, STEP_TOTAL);
  return {
    formData,
    isLoading,
    step,
    handleNextStep,
    handlePreviousStep,
    isLastStep,
    isFirstStep
  };
};
__sfc_main.components = Object.assign({
  FormDataSeller,
  FormAddress
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
  <div>
    <FormDataSeller
      v-show="step === 0"
      :handle-next="handleNextStep"
      :handle-previous="handlePreviousStep"
      :is-last-step="isLastStep"
      :is-first-step="isFirstStep"
      :form-data="formData.formStep01"
    />

    <FormAddress
      v-show="step === 1"
      :handle-next="handleNextStep"
      :handle-previous="handlePreviousStep"
      :is-last-step="isLastStep"
      :is-first-step="isFirstStep"
      :form-data="formData.formStep02"
    />

    <o-loading :full-page="true" :active.sync="isLoading" />
  </div>
</template>
